// src/components/select/GranularitySelector.tsx

import { MenuItem, TextField } from '@mui/material'
import { ChangeEvent } from 'react'

type Props = {
  data?: { title: string; value: string; disabled: boolean }[]
  title?: string
  value?: string
  variant?: 'standard' | 'outlined' | 'filled'
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export const GranularitySelector = ({
  data = [
    { title: 'Stündlich', value: 'd', disabled: false },
    { title: 'Täglich', value: 'm', disabled: false },
    { title: 'Monatlich', value: 'y', disabled: false },
    { title: 'Jährlich', value: 'yy', disabled: false },
  ],
  title = 'Granularität',
  variant = 'standard',
  value,
  onChange,
  ...rest
}: Props) => (
  <TextField
    label={title}
    select
    value={value}
    variant={variant}
    onChange={onChange}
    {...rest}
  >
    {data.map(item => (
      <MenuItem disabled={item.disabled} key={item.title} value={item.value}>
        {item.title}
      </MenuItem>
    ))}
  </TextField>
)
